<template>
  <Teleport to="body">
    <div
      v-if="show"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0,0,0,0.5)"
      @click.self="close"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="btn-close" @click="close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingDetail" class="text-center py-4 text-muted">Cargando detalle...</div>
            <div v-else-if="detailError" class="alert alert-danger">{{ detailError }}</div>
            <template v-else-if="driverView">
              <div class="row">
                <div class="col-md-4 text-center mb-4">
                  <img
                    :src="driverView.driverPhoto || placeholderAvatar"
                    alt="Foto conductor"
                    class="img-fluid rounded-circle mb-3"
                    style="max-width: 180px; height: 180px; object-fit: cover"
                  />
                  <h5>{{ driverView.name || '—' }}</h5>
                  <span class="badge" :class="statusBadgeClass">{{ driverView.status || '—' }}</span>
                  <p v-if="driverView.vehiclePlate" class="mt-2 mb-0 text-muted small">
                    Patente: {{ driverView.vehiclePlate }}
                  </p>
                </div>
                <div class="col-md-8">
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label fw-semibold text-muted small">Teléfono</label>
                      <p class="mb-0">{{ driverView.phone || '—' }}</p>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-semibold text-muted small">Número de cuenta</label>
                      <p class="mb-0">{{ driverView.paymentAccount || '—' }}</p>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-semibold text-muted small">Correo</label>
                      <p class="mb-0">{{ driverView.email || '—' }}</p>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-semibold text-muted small">Banco</label>
                      <p class="mb-0">{{ driverView.bankType || '—' }}</p>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-semibold text-muted small">Vigencia de la Licencia</label>
                      <p class="mb-0">{{ formatTimestamp(driverView.credentialExpirationDate) }}</p>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-semibold text-muted small">Vigencia del permiso de circulación</label>
                      <p class="mb-0">{{ formatTimestamp(driverView.permitExpirationDate) }}</p>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-semibold text-muted small">Vigencia de los antecedentes penales</label>
                      <p class="mb-0">{{ formatTimestamp(driverView.criminalRecordExpirationDate) }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <h6 class="mb-3">Documentos e imágenes</h6>
              <div class="row g-3">
                <div class="col-6 col-md-4">
                  <label class="form-label fw-semibold text-muted small">Foto frontal del carnet</label>
                  <a v-if="driverView.frontIDPhoto" :href="driverView.frontIDPhoto" target="_blank" class="d-block">
                    <img :src="driverView.frontIDPhoto" alt="Carnet frontal" class="img-fluid rounded border" style="max-height: 120px; object-fit: cover" />
                  </a>
                  <p v-else class="text-muted small mb-0">—</p>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label fw-semibold text-muted small">Foto posterior del carnet</label>
                  <a v-if="driverView.backIDPhoto" :href="driverView.backIDPhoto" target="_blank" class="d-block">
                    <img :src="driverView.backIDPhoto" alt="Carnet posterior" class="img-fluid rounded border" style="max-height: 120px; object-fit: cover" />
                  </a>
                  <p v-else class="text-muted small mb-0">—</p>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label fw-semibold text-muted small">Foto frontal de la Licencia</label>
                  <a v-if="driverView.frontCredentialPhoto" :href="driverView.frontCredentialPhoto" target="_blank" class="d-block">
                    <img :src="driverView.frontCredentialPhoto" alt="Licencia frontal" class="img-fluid rounded border" style="max-height: 120px; object-fit: cover" />
                  </a>
                  <p v-else class="text-muted small mb-0">—</p>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label fw-semibold text-muted small">Foto posterior de la licencia</label>
                  <a v-if="driverView.backCredentialPhoto" :href="driverView.backCredentialPhoto" target="_blank" class="d-block">
                    <img :src="driverView.backCredentialPhoto" alt="Licencia posterior" class="img-fluid rounded border" style="max-height: 120px; object-fit: cover" />
                  </a>
                  <p v-else class="text-muted small mb-0">—</p>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label fw-semibold text-muted small">Permiso de circulación del vehículo</label>
                  <a v-if="driverView.vehiclePermission" :href="driverView.vehiclePermission" target="_blank" class="d-block">
                    <img :src="driverView.vehiclePermission" alt="Permiso vehículo" class="img-fluid rounded border" style="max-height: 120px; object-fit: cover" />
                  </a>
                  <p v-else class="text-muted small mb-0">—</p>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label fw-semibold text-muted small">Foto del vehículo</label>
                  <a v-if="driverView.vehiclePhoto" :href="driverView.vehiclePhoto" target="_blank" class="d-block">
                    <img :src="driverView.vehiclePhoto" alt="Vehículo" class="img-fluid rounded border" style="max-height: 120px; object-fit: cover" />
                  </a>
                  <p v-else class="text-muted small mb-0">—</p>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label fw-semibold text-muted small">Archivo de antecedentes penales</label>
                  <a v-if="driverView.criminalRecord" :href="driverView.criminalRecord" target="_blank" class="btn btn-outline-primary btn-sm">
                    Ver documento
                  </a>
                  <p v-else class="text-muted small mb-0">—</p>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label fw-semibold text-muted small">Archivo de inicio de actividades SII</label>
                  <a v-if="driverView.sii" :href="driverView.sii" target="_blank" class="btn btn-outline-primary btn-sm">
                    Ver documento
                  </a>
                  <p v-else class="text-muted small mb-0">—</p>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close">Cerrar</button>
            <template v-if="mode === 'solicitudes'">
              <button
                type="button"
                class="btn btn-danger"
                :disabled="updating || loadingDetail"
                @click="rechazar"
              >
                <span v-if="updating">Procesando...</span>
                <span v-else>Rechazar</span>
              </button>
              <button
                type="button"
                class="btn btn-primary"
                :disabled="updating || loadingDetail"
                @click="aprobar"
              >
                <span v-if="updating">Procesando...</span>
                <span v-else>Aprobar</span>
              </button>
            </template>
            <button
              v-else-if="mode === 'activos' || mode === 'inactivar'"
              type="button"
              class="btn btn-warning"
              :disabled="updating || loadingDetail"
              @click="inactivar"
            >
              <span v-if="updating">Procesando...</span>
              <span v-else>Desactivar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import Swal from 'sweetalert2';
import {
  approveConductor,
  deactivateConductor,
  fetchConductorDetail,
  rejectConductor,
} from '@/services/conductoresApi';

export default {
  name: 'DriverModal',
  props: {
    show: { type: Boolean, default: false },
    driver: { type: Object, default: null },
    mode: {
      type: String,
      default: 'view',
      validator: (v) => ['solicitudes', 'activos', 'inactivar', 'view'].includes(v),
    },
  },
  emits: ['close', 'updated'],
  data() {
    return {
      updating: false,
      loadingDetail: false,
      detailError: '',
      driverDetail: null,
      placeholderAvatar: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"%3E%3Ccircle fill="%23ddd" cx="40" cy="40" r="40"/%3E%3Ctext fill="%23999" x="50%25" y="55%25" dominant-baseline="middle" text-anchor="middle" font-size="24"%3E?%3C/text%3E%3C/svg%3E',
    };
  },
  computed: {
    modalTitle() {
      if (this.mode === 'solicitudes') return 'Solicitud de conductor';
      if (this.mode === 'activos' || this.mode === 'inactivar') return 'Conductor activo';
      return 'Detalle del conductor';
    },
    driverView() {
      return this.driverDetail || this.driver;
    },
    statusBadgeClass() {
      const s = (this.driverView?.status || '').toLowerCase();
      if (s === 'activo') return 'bg-success';
      if (s === 'solicitud') return 'bg-warning text-dark';
      if (s === 'inactivo') return 'bg-danger';
      if (s === 'enviaje' || s === 'tripaceptado') return 'bg-info text-dark';
      return 'bg-light text-dark';
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(visible) {
        if (visible && this.driver?.id) {
          this.loadDetail();
        } else if (!visible) {
          this.driverDetail = null;
          this.detailError = '';
        }
      },
    },
  },
  methods: {
    async loadDetail() {
      this.loadingDetail = true;
      this.detailError = '';
      try {
        this.driverDetail = await fetchConductorDetail(this.driver.id);
      } catch (err) {
        this.detailError = err.message || 'No se pudo cargar el detalle';
        this.driverDetail = null;
      } finally {
        this.loadingDetail = false;
      }
    },
    formatTimestamp(ts) {
      if (!ts) return '—';
      let date;
      if (typeof ts === 'object' && ts.seconds != null) {
        date = new Date(ts.seconds * 1000);
      } else if (typeof ts === 'number') {
        date = new Date(ts > 1e10 ? ts : ts * 1000);
      } else {
        date = new Date(ts);
      }
      if (Number.isNaN(date.getTime())) return '—';
      return date.toLocaleDateString('es-CL', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
    close() {
      this.$emit('close');
    },
    async aprobar() {
      if (!this.driver?.id) return;
      this.updating = true;
      try {
        await approveConductor(this.driver.id);
        await Swal.fire({
          icon: 'success',
          title: 'Aprobado',
          text: 'Conductor aprobado correctamente',
          timer: 1600,
          showConfirmButton: false,
        });
        this.$emit('updated');
        this.close();
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.message || 'No se pudo aprobar',
        });
      } finally {
        this.updating = false;
      }
    },
    async rechazar() {
      if (!this.driver?.id) return;
      const confirm = await Swal.fire({
        icon: 'warning',
        title: '¿Rechazar solicitud?',
        text: 'El conductor pasará a inactivo.',
        showCancelButton: true,
        confirmButtonText: 'Sí, rechazar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;

      this.updating = true;
      try {
        await rejectConductor(this.driver.id);
        await Swal.fire({
          icon: 'success',
          title: 'Rechazado',
          text: 'Solicitud rechazada',
          timer: 1600,
          showConfirmButton: false,
        });
        this.$emit('updated');
        this.close();
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.message || 'No se pudo rechazar',
        });
      } finally {
        this.updating = false;
      }
    },
    async inactivar() {
      if (!this.driver?.id) return;
      this.updating = true;
      try {
        await deactivateConductor(this.driver.id);
        await Swal.fire({
          icon: 'success',
          title: 'Desactivado',
          text: 'Conductor desactivado',
          timer: 1600,
          showConfirmButton: false,
        });
        this.$emit('updated');
        this.close();
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.message || 'No se pudo desactivar',
        });
      } finally {
        this.updating = false;
      }
    },
  },
};
</script>
